import data from "../../.sourceflow/values.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const values_helper = new CollectionHelper(data);
